module.exports = __webpack_public_path__ + "img/character-1@2x.631731e3.png";